import React, { Component } from 'react'

import AspectRatio from '../../atoms/AspectRatio'
import FontIcon from '../../atoms/FontIcon'
import Font from '../../atoms/Font'
import Valign from '../../atoms/Valign'
import BoxShadow from '../../atoms/BoxShadow'
import T from '../../translate/T'

import { date } from '../../helpers/Formatter'

import style from './style.css'

export default class BoxEvent extends Component {

    render() {
        this.data = this.props.data
        return (
            <BoxShadow className={style.box}>
                {this.data.cover && (
                    <AspectRatio image={this.data.cover} ratio='3x1' />
                )}
            
                <div className={style.container}>
                    <div className={style.barLeft}>
                        <div className={style.iconTop}>
                            <FontIcon name='star' />
                        </div>
                        <div className={style.textV}>                            
                            {T.txt(`c_${this.props.data.type}`)}
                        </div>
                        <div className={style.actionIcon} style={{display: 'none'}}>
                            {/* <Icon name='bell' />                         */}
                        </div>
                    </div>

                    <div className={style.content}>
                        <div style={{ display: 'flex' }}>
                            {this.data.date && (
                                <div className={style.date}>
                                    <Font size='15' color='#999999' style={{position: 'relative', right: '4px'}}>{date(this.data.date).month('br').abbrev.toUpperCase()}</Font>
                                    <br />
                                    <Font size='50' color='#999999' style={{position: 'relative', top: '-8px'}}>{date(this.data.date).day(true)}</Font>
                                </div>
                            )}
                            <div className={style.title}>
                                <Font weight='bold' color='#545454' size='16'>
                                    {this.data.title || ''}
                                </Font>
                            </div>
                        </div>
                        <div className={style.location}>
                            <Valign>
                                <span  style={{
                                    color: '#ff5500',
                                    fontSize: '12px',
                                    marginRight: '10px'
                                }} >
                                    <FontIcon name='pin'/>
                                </span>
                                <Font size='14' color='#545454' className={style.city}>
                                {this.data.city} {this.data.state_abbreviation && `(${this.data.state_abbreviation})`}
                                {this.data.location || ''}
                                </Font> 
                            </Valign>
                        </div>
                    </div>
                </div>
            </BoxShadow>
        )
    }
}


// WEBPACK FOOTER //
// ./src/SPRINTA/molecules/BoxEvent/index.js